module.exports = __webpack_public_path__ + "static/img/honner3.c41b8da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honner/honner3.png
// module id = srM2
// module chunks = 0